import { Component, input, OnInit, output, signal } from '@angular/core';
import { GeneratedAssignment } from '@repo/backend-api-spec';
import { UnexpectedStateError } from '@gametailors/web-core/errors';
import { KeyboardActivityResult } from './keyboard-activity-result';

interface TargetWord {
  word: string;
  parts: string[];
}

// TODO: this will be retrieved from the backend later
const targetWords = [
  { word: 'berg', parts: ['b', 'e', 'r', 'g'] },
  { word: 'boom', parts: ['b', 'oo', 'm'] },
  { word: 'huis', parts: ['h', 'ui', 's'] },
  { word: 'bank', parts: ['b', 'a', 'nk'] },
  { word: 'haai', parts: ['h', 'aai'] },
  { word: 'mooi', parts: ['m', 'ooi'] },
  { word: 'boek', parts: ['b', 'oe', 'k'] },
  { word: 'leeuw', parts: ['l', 'eeuw'] },
  { word: 'nieuw', parts: ['n', 'ieuw'] },
  { word: 'ijs', parts: ['ij', 's'] },
  { word: 'doos', parts: ['d', 'oo', 's'] },
];

@Component({ template: '' })
export abstract class BasicKeyboardActivity implements OnInit {
  public readonly assignment = input<GeneratedAssignment>();
  public readonly finishedItem = output<KeyboardActivityResult>();
  public readonly finishedAssignment = output();

  public readonly targetWord = signal<TargetWord | undefined>(undefined);

  private itemIndex = 0;
  private madeMistake = false;
  private startedAt = Date.now();

  ngOnInit() {
    this.setNewTargetWord();
  }

  public completeWord() {
    const assignment = this.assignment();
    if (!assignment) throw new UnexpectedStateError('Expected assignment to be set');

    const isDone = assignment.items.length <= this.itemIndex;

    this.finishedItem.emit({
      content: this.targetWord()!.word,
      madeMistake: this.madeMistake,
      timeMs: Date.now() - this.startedAt,
      finishedActivity: isDone,
    });

    if (!isDone) {
      console.debug(`Completed word ${this.itemIndex} of ${assignment.items.length}`);
      this.setNewTargetWord();
      return;
    }

    alert('Assignment complete!');
    this.finishedAssignment.emit();
  }

  public onWrongInput() {
    this.madeMistake = true;
  }

  private setNewTargetWord() {
    this.madeMistake = false;
    this.startedAt = Date.now();

    const assignment = this.assignment();
    if (!assignment) throw new UnexpectedStateError('Expected assignment to be set');

    const content = assignment.items[this.itemIndex]?.content;
    if (!content) throw new UnexpectedStateError(`Could not find assignment item with index ${this.itemIndex}`);

    const newWord = targetWords.find((w) => w.word === content);
    if (!newWord) throw new UnexpectedStateError('Could not find word in target words list.');

    console.debug('Set new target word: ', newWord);
    this.targetWord.set(newWord);
    this.itemIndex++;
  }
}
